<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eKchIS/tc-custom/9781479858910.jpg?1705766125495" alt="This image is the cover for the book Justice in a New World, Religion and Social Transformation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Justice in a New World, Religion and Social Transformation
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A historical and legal examination of the conflict and interplay between settler and indigenous laws in the New World</b><br/><br/>As British and Iberian empires expanded across the New World, differing notions of justice and legality played out against one another as settlers and indigenous people sought to negotiate their relationship. In order for settlers and natives to learn from, maneuver, resist, or accommodate each other, they had to grasp something of each other's legal ideas and conceptions of justice.<br/><br/>This ambitious volume advances our understanding of how natives and settlers in both the British and Iberian New World empires struggled to use the other’s ideas of law and justice as a political, strategic, and moral resource.  In so doing, indigenous people and settlers alike changed their own practices of law and dialogue about justice.  Europeans and natives appealed to imperfect understandings of their interlocutors’ notions of justice and advanced their own conceptions during workaday negotiations, disputes, and assertions of right.  Settlers’ and indigenous peoples’ legal presuppositions shaped and sometimes misdirected their attempts to employ each other’s law. <br/><br/>Natives and settlers construed and misconstrued each other's legal commitments while learning about them, never quite sure whether they were on solid ground.  Chapters explore the problem of “legal intelligibility”: How and to what extent did settler law and its associated notions of justice became intelligible—tactically, technically and morally—to natives, and vice versa?  To address this question, the volume offers a critical comparison between English and Iberian New World empires.  Chapters probe such topics as treaty negotiations, land sales, and the corporate privileges of indigenous peoples.  Ultimately, Justice in a New World offers both a deeper understanding of the transformation of notions of justice and law among settlers and indigenous people, and a dual comparative study of what it means for laws and moral codes to be legally intelligible.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian P Owensby, Richard J Ross
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42992a68